package com.isaias.fyattravel.web.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.isaias.fyattravel.web.i18n.WebStringKey
import com.isaias.fyattravel.web.i18n.WebStrings
import com.isaias.fyattravel.web.theme.ThemeColors

private const val ICON_FLIGHT = """<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12h20"/><path d="M14 2l-4 10 4 10"/></svg>"""
private const val ICON_HOTEL = """<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg>"""
private const val ICON_CAR = """<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m4 0a2 2 0 104 0m-4 0a2 2 0 114 0"/><path d="M19 17h2a1 1 0 001-1v-4a1 1 0 00-.8-.9l-5-1A1 1 0 0014 10h-4a1 1 0 00-1 .9l-5 1A1 1 0 003 12v4a1 1 0 001 1h2"/></svg>"""
private const val ICON_VISA = """<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><path d="M6 15h.01"/><path d="M10 15h.01"/></svg>"""
private const val ICON_TOUR = """<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>"""

/**
 * Service icon tabs with black default icons and gold-gradient active state.
 */
@Composable
fun ServiceTabs(
    activeRoute: String,
    onNavigate: (String) -> Unit,
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            gap(1.2.em)
            marginBottom(1.5.em)
            flexWrap(FlexWrap.Wrap)
            justifyContent(JustifyContent.Center)
            property("@media (max-width: 640px)", "{ gap: 0.9em; }")
        }
    }) {
        ServiceIconTab(
            iconSvg = ICON_FLIGHT,
            label = WebStrings.t(WebStringKey.EXPLORE_FLIGHTS),
            active = activeRoute == "/flights"
        ) { onNavigate("/flights") }
        ServiceIconTab(
            iconSvg = ICON_HOTEL,
            label = WebStrings.t(WebStringKey.EXPLORE_STAYS),
            active = activeRoute == "/stays"
        ) { onNavigate("/stays") }
        ServiceIconTab(
            iconSvg = ICON_CAR,
            label = WebStrings.t(WebStringKey.CAR_RENTAL),
            active = activeRoute == "/cars"
        ) { onNavigate("/cars") }
        ServiceIconTab(
            iconSvg = ICON_VISA,
            label = WebStrings.t(WebStringKey.EXPLORE_VISA),
            active = activeRoute == "/visa_logo"
        ) { onNavigate("/visa_logo") }
        ServiceIconTab(
            iconSvg = ICON_TOUR,
            label = WebStrings.t(WebStringKey.CATEGORIES_FILTER_TOURS),
            active = activeRoute == "/explore"
        ) { onNavigate("/explore") }
    }
}

@Composable
private fun ServiceIconTab(
    iconSvg: String,
    label: String,
    active: Boolean = false,
    onClick: () -> Unit,
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            gap(0.5.em)
            cursor("pointer")
            property("user-select", "none")
        }
        onClick { onClick() }
    }) {
        // Icon circle
        Div({
            style {
                width(52.px)
                height(52.px)
                borderRadius(50.percent)
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.Center)
                if (active) {
                    property("background", "linear-gradient(135deg, #AE7930, #8B5E24)")
                    property("box-shadow", "0 4px 12px rgba(174,121,48,0.35)")
                    color(Color("#FFFFFF"))
                } else {
                    backgroundColor(Color("#F2F2F2"))
                    color(Color("#000000"))
                }
                property("transition", "all 0.25s ease")
            }
        }) {
            Span({
                ref { el ->
                    el.innerHTML = iconSvg
                    onDispose {}
                }
            })
        }
        // Label
        Span({
            style {
                fontSize(0.85.em)
                fontWeight(if (active) "700" else "500")
                color(if (active) Color("#AE7930") else Color("#333333"))
                property("transition", "color 0.25s ease")
            }
        }) { Text(label) }
    }
}
